// extracted by mini-css-extract-plugin
export default {"wrapper":"ActionCardTitle_wrapper__5pG-5","title":"ActionCardTitle_title__-r9AF","actions":"ActionCardTitle_actions__rSR2H","action":"ActionCardTitle_action__kjjRO"};